import { Box, Typography } from '@mui/material';
import React, { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import axiosInstance from '../../../api/axiosInstance';
import { removeData } from '../../../Redux/Feature/AdminSlice';
import parse from "html-react-parser";


function DentalProfile() {
    
    const navigate = useNavigate()
    const dispatch = useDispatch()
    const admin = useSelector((state) => state.AdminData.admin);

    const [dentalData, setDentalData] = useState({})
    const fetchHostelData = async () => {
        try {
          const response = await axiosInstance.get(
            `${process.env.REACT_APP_API_URL}get-dental-clinic/${admin?.id}`
          );
          setDentalData(response?.data?.data);
        } catch (error) {
          console.log(error, "fetchHostel");
          if(error.response.status === 401 || error.response.status === 403){
            navigate('/Admin/login')
            dispatch(removeData())
        }
        }
      };
    
      useEffect(() => {
        if (admin?.id) {
          fetchHostelData();
        }
      }, [admin]);

  return (
    <div>
        <Box>
            <Box>
                <Typography sx={{fontWeight : 700, color : '#003893'}}>Title</Typography>
                <Typography sx={{mt : 1.2, backgroundColor : '#F0F9FF', p : '23px', borderRadius : '8px'}}>{dentalData?.title?.en || '-'}</Typography>
            </Box>
            <Box sx={{mt : 1.6}}>
                <Typography sx={{fontWeight : 700, color : '#003893'}}>Location</Typography>
                <Typography sx={{mt : 1.2, backgroundColor : '#F0F9FF', p : '23px', borderRadius : '8px'}}>{dentalData?.location || '-'}</Typography>
            </Box>
            <Box sx={{mt : 1.6}}>
                <Typography sx={{fontWeight : 700, color : '#003893'}}>Contact</Typography>
                <Typography sx={{mt : 1.2, backgroundColor : '#F0F9FF', p : '23px', borderRadius : '8px'}}>+{dentalData?.contact || '-'}</Typography>
            </Box>
            <Box sx={{mt : 1.6}}>
                <Typography sx={{fontWeight : 700, color : '#003893'}}>Email</Typography>
                <Typography sx={{mt : 1.2, backgroundColor : '#F0F9FF', p : '23px', borderRadius : '8px'}}>{dentalData?.email || '-'}</Typography>
            </Box>
            <Box sx={{mt : 1.6}}>
                <Typography sx={{fontWeight : 700, color : '#003893'}}>Description</Typography>
                <Typography sx={{mt : 1.2, backgroundColor : '#F0F9FF', p : '23px', borderRadius : '8px'}}>{Boolean(dentalData?.description?.en)
                            ? parse(dentalData?.description?.en)
                            : "-"}</Typography>
            </Box>
        </Box>
    </div>
  )
}

export default DentalProfile